module.exports = __webpack_public_path__ + "img/ct.310fea17.jpg";